export const CHATBOT_API_PATHS = {
  CHAT: '/chat',
  HISTORY: '/history',
  HISTORY_GROUPED_SUFFIX: '/grouped',
  FEEDBACK: '/feedback',
  FAQ_INDEX_BUILD: '/faq/index-build',
  CONTACT_INDEX_BUILD: '/contact/index-build',
} as const;

export const CHATBOT_FEEDBACK_TYPES = {
  THUMBS_UP: 'thumbs_up',
  THUMBS_DOWN: 'thumbs_down',
} as const;

export const CHATBOT_TEXT = {
  OPEN_CHAT_ARIA_LABEL: 'Open chat assistant',
  CLOSE_CHAT_ARIA_LABEL: 'Close chat assistant',
  HEADER_TITLE: 'I am your My Account Assistant',
  HEADER_TITLE_PREFIX: 'I am your',
  HEADER_TITLE_BRAND_MY: 'My',
  HEADER_TITLE_BRAND_ACCOUNT: 'Account',
  HEADER_TITLE_SUFFIX: 'Assistant',
  HEADER_SUBTITLE: 'Always here to help',
  INPUT_PLACEHOLDER: 'Type your message...',
  SEND_BUTTON_ARIA_LABEL: 'Send chat message',
  DEFAULT_BOT_GREETING: "Hello! I'm your Assistant. How can I help you today?",
  FALLBACK_BOT_REPLY: 'I understand your query. Let me help you with that',
  LOADING: 'Loading...',
  HISTORY_LOADING: 'Loading history...',
  HISTORY_EMPTY: 'No chat history found yet.',
  HISTORY_ERROR: 'Unable to load chat history right now.',
  FEEDBACK_THUMBS_UP_LABEL: 'Thumbs up',
  FEEDBACK_THUMBS_DOWN_LABEL: 'Thumbs down',
  FEEDBACK_ARIA_LABEL_PREFIX: 'Submit chatbot feedback',
  SCROLL_TO_BOTTOM_LABEL: 'Scroll to latest messages',
  DATE_TODAY: 'Today',
  DATE_YESTERDAY: 'Yesterday',
  DATE_LOCALE: 'en-GB',
  HISTORY_USER_ID_PREFIX: 'history-user-',
  HISTORY_BOT_ID_PREFIX: 'history-bot-',
} as const;

export const CHATBOT_LOADING_WORDS = [
  'Thinking...',
  'Analysing...',
  'Reviewing...',
  'Checking...',
  'Preparing...',
  'Processing...',
  'Composing...',
] as const;

export const CHATBOT_CONFIG = {
  MAX_TEXTAREA_HEIGHT_PX: 96,
  SCROLL_THRESHOLD_PX: 180,
  SCROLL_THRESHOLD_RATIO: 0.5,
  DAY_MS: 24 * 60 * 60 * 1000,
} as const;
